function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Calendar hero carousel (NLRSUPPORT-401).
 * Slides are stacked in the DOM; the active one is toggled via `.is-active`.
 * Arrows/counter/autoplay only run when there is more than one slide.
 */
var ROOT = '[data-component="calendarHero"]';
var AUTOPLAY_MS = 6000;
var SWIPE_THRESHOLD = 50;
var CalendarHero = /*#__PURE__*/function () {
  function CalendarHero(root) {
    _classCallCheck(this, CalendarHero);
    this.root = root;
    this.slides = Array.from(root.querySelectorAll('[data-slide]'));
    this.counter = root.querySelector('[data-element="counter"]');
    this.prevBtn = root.querySelector('[data-element="prev"]');
    this.nextBtn = root.querySelector('[data-element="next"]');
    this.index = 0;
    this.timer = null;
    this.dragX = null;
    this.dragging = false;
    if (this.slides.length <= 1) return;
    this.bind();
    this.start();
  }
  return _createClass(CalendarHero, [{
    key: "bind",
    value: function bind() {
      var _this = this;
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          _this.go(_this.index - 1);
          _this.start();
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          _this.go(_this.index + 1);
          _this.start();
        });
      }
      this.root.addEventListener('mouseenter', function () {
        return _this.stop();
      });
      this.root.addEventListener('mouseleave', function () {
        return _this.start();
      });
      this.root.addEventListener('pointerdown', function (e) {
        _this.dragX = e.clientX;
        _this.dragging = false;
      });
      this.root.addEventListener('pointermove', function (e) {
        if (_this.dragX !== null && Math.abs(e.clientX - _this.dragX) > 8) _this.dragging = true;
      });
      this.root.addEventListener('pointerup', function (e) {
        if (_this.dragX === null) return;
        var delta = e.clientX - _this.dragX;
        _this.dragX = null;
        if (Math.abs(delta) < SWIPE_THRESHOLD) return;
        _this.go(_this.index + (delta < 0 ? 1 : -1));
        _this.start();
      });

      // Suppress the slide link navigation when the pointer was dragged (swipe).
      this.slides.forEach(function (slide) {
        slide.addEventListener('click', function (e) {
          if (_this.dragging) {
            e.preventDefault();
            _this.dragging = false;
          }
        });
      });
    }
  }, {
    key: "go",
    value: function go(target) {
      var _this2 = this;
      var n = this.slides.length;
      this.index = (target % n + n) % n;
      this.slides.forEach(function (slide, idx) {
        var active = idx === _this2.index;
        slide.classList.toggle('is-active', active);
        if (active) slide.removeAttribute('aria-hidden');else slide.setAttribute('aria-hidden', 'true');
      });
      if (this.counter) this.counter.textContent = "".concat(this.index + 1, "/").concat(n);
    }
  }, {
    key: "start",
    value: function start() {
      var _this3 = this;
      this.stop();
      this.timer = setInterval(function () {
        return _this3.go(_this3.index + 1);
      }, AUTOPLAY_MS);
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }]);
}();
Array.from(document.querySelectorAll(ROOT)).forEach(function (root) {
  return new CalendarHero(root);
});